import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { BenefitLimit } from '@models/BenefitLimit';
import { API_V1_BASE } from '@config';
import { snakes } from '@utils/lodash';

export type GetAllBenefitLimitParams = {
  benefitTemplateId: number;
};

export class BenefitLimitApi {
  static getAll = async (params: GetAllBenefitLimitParams) => {
    return await authAxios.get(`${API_V1_BASE}/user/benefit_limits`, { params: snakes(params) }).then((response) => humps(response.data) as BenefitLimit[]);
  };
}
